import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root:{
    flexGrow: 1,
  },
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
  progress:{
    margin: theme.spacing.unit * 45,
  }
})

class CheckingTimeLimit extends Component{
  render(){
    const { classes } = this.props;
    return (

      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >

      <div className={classes.root}>
        <CircularProgress className={classes.progress} color="secondary" size={120} />
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(CheckingTimeLimit);



// WEBPACK FOOTER //
// ./src/components/Login/CheckingTimeLimit.js